import { useMemo } from 'react';

import { OperationStatusType } from 'api/types/entity/operation';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  ChangeStatusFormSchemaProps,
  useFormContext,
  Field,
} from 'modules/operation/operation/forms/changeStatusForm';

interface Props extends ChangeStatusFormSchemaProps {}

export const FormContent = ({ availableStatusesMap }: Props) => {
  const { t } = useTranslation();
  const { values } = useFormContext();

  const { isRequiredReason } = useMemo(() => {
    const status = values.status?.value;
    return (
      availableStatusesMap[status] || {
        isRequiredReason: false,
      }
    );
  }, [values.status, availableStatusesMap]);

  const availableStatuses = useMemo(
    () => Object.keys(availableStatusesMap) as OperationStatusType[],
    [availableStatusesMap]
  );

  return (
    <Stack spacing={12}>
      <Field.Autocomplete
        showRequiredMark
        label={t('operation.operation.dialogStatusChange.fields.status.label')}
        name="status"
        optionLabelKey="label"
        options={availableStatuses.map((status) => ({
          label: t(`operation.operationStatuses.${status}`),
          value: status,
        }))}
        optionValueKey="value"
        placeholder={t(
          'operation.operation.dialogStatusChange.fields.status.placeholder'
        )}
      />
      {isRequiredReason && (
        <Field.Text
          showRequiredMark
          label={t(
            'operation.operation.dialogStatusChange.fields.reason.label'
          )}
          name="reason"
          placeholder={t(
            'operation.operation.dialogStatusChange.fields.reason.placeholder'
          )}
        />
      )}
    </Stack>
  );
};
